import { render } from "./Dashboard.vue?vue&type=template&id=6532b144&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=6532b144&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6532b144"]])

export default __exports__